/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import { startOfDay } from "date-fns";

export function maxDate(date: Date, minDate: Date) {
	if (minDate.getFullYear() < date.getFullYear()) return date;

	if (minDate.getMonth() < date.getMonth()) return date;

	if (minDate.getDate() < date.getDate()) return date;

	const newDate = new Date(date);
	newDate.setFullYear(
		minDate.getFullYear(),
		minDate.getMonth(),
		minDate.getDate(),
	);
	return newDate;
}

export function minDate(date: Date, maxDate: Date) {
	if (maxDate.getFullYear() > date.getFullYear()) return date;

	if (maxDate.getMonth() > date.getMonth()) return date;

	if (maxDate.getDate() > date.getDate()) return date;

	const newDate = new Date(date);
	newDate.setFullYear(
		maxDate.getFullYear(),
		maxDate.getMonth(),
		maxDate.getDate(),
	);
	return newDate;
}

export function clampDate(date: Date, min?: Date | null, max?: Date | null) {
	if (min) date = maxDate(date, min);

	if (max) date = minDate(date, max);

	return date;
}

export function maxTime(date: Date, minDate: Date) {
	if (minDate.getHours() < date.getHours()) return date;

	if (minDate.getMinutes() < date.getMinutes()) return date;

	if (minDate.getSeconds() < date.getSeconds()) return date;

	if (minDate.getMilliseconds() < date.getMilliseconds()) return date;

	const newDate = new Date(date);
	newDate.setHours(
		minDate.getHours(),
		minDate.getMinutes(),
		minDate.getSeconds(),
		minDate.getMilliseconds(),
	);
	return newDate;
}

export function minTime(date: Date, maxDate: Date) {
	if (maxDate.getHours() > date.getHours()) return date;

	if (maxDate.getMinutes() > date.getMinutes()) return date;

	if (maxDate.getSeconds() > date.getSeconds()) return date;

	if (maxDate.getMilliseconds() > date.getMilliseconds()) return date;

	const newDate = new Date(date);
	newDate.setHours(
		maxDate.getHours(),
		maxDate.getMinutes(),
		maxDate.getSeconds(),
		maxDate.getMilliseconds(),
	);
	return newDate;
}

/**
 * uikit TimeInput returns start of the day plus the typed time in milliseconds,
 * an hour off on a DST switch day. Recover the typed hours and minutes and set
 * them on `base` as wall-clock time.
 */
export function setTypedTime(base: Date, typed: Date) {
	const typedMs = typed.getTime() - startOfDay(base).getTime();
	const result = new Date(base);
	result.setHours(
		Math.floor(typedMs / 3_600_000),
		Math.floor((typedMs % 3_600_000) / 60_000),
		0,
		0,
	);
	return result;
}

/**
 * Moves `base` to the calendar day of `day`, keeping the time of `base`.
 * Year, month and day go in one call: setting the month first turns
 * 31.10 + November into "31.11", which rolls over to 01.12.
 */
export function setCalendarDay(base: Date, day: Date) {
	const result = new Date(base);
	result.setFullYear(day.getFullYear(), day.getMonth(), day.getDate());
	return result;
}

export function clampTime(date: Date, min?: Date | null, max?: Date | null) {
	if (min) date = maxTime(date, min);

	if (max) date = minTime(date, max);

	return date;
}
